import { render, staticRenderFns } from "./root-pogs-admin.vue?vue&type=template&id=59a716f8&scoped=true&"
import script from "./root-pogs-admin.vue?vue&type=script&lang=js&"
export * from "./root-pogs-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a716f8",
  null
  
)

export default component.exports